import React, { useEffect, useReducer, useState } from 'react'
import PropTypes from 'prop-types'

import EventEditorFormDefault from './EventEditorFormDefault'
import EventEditorFormPrisma from './EventEditorFormPrisma'
import { initStateObject, objectReducer } from 'reducers/default'
import { fetchCampaigns } from 'api/campaigns'
import { isProductEntry } from 'utils/helpers'

export default function EventFrom(props) {
  const [category, setCategory] = useState(props.event.category)
  const [activeTab, setActiveTab] = useState(
    isProductEntry(props.event.category)
      ? (Array.isArray(props.event.special_ad_category) && props.event.special_ad_category.length > 0) ? 'special' : 'default'
      : 'event'
  )

  const [campaignsState, dispatchCampaigns] = useReducer(objectReducer, initStateObject)

  useEffect(() => {
    if (props.event?.id) {
      fetchCampaigns(dispatchCampaigns, props.event.id, { page: 1, page_limit: 50 })
    }
  }, [props.event?.id])

  const campaigns = campaignsState.content?.items || []

  const isPublished = campaigns.some(campaign => campaign.published)

  return (
    <>
      {(activeTab === 'default' || activeTab === 'special') && (
        <EventEditorFormPrisma 
          {...props} 
          onCategoryChanged={setCategory} 
          category={category} 
          activeTab={activeTab} 
          onTabChanged={setActiveTab}
          isPublished={isPublished}
        />
      )}
      {activeTab === 'event' && (
        <EventEditorFormDefault 
          {...props} 
          onCategoryChanged={setCategory} 
          category={category} 
          activeTab={activeTab} 
          onTabChanged={setActiveTab}
          isPublished={isPublished}
        />
      )}
    </>
  )
}

EventFrom.propTypes = {
  event: PropTypes.object,
  postUpdatedEvent: PropTypes.func,
  renderFormButtons: PropTypes.func,
  onFormChanged: PropTypes.func,
}
